import { environment } from '@environment/environments';

export const CREATE_OPPORTUNITY_URL = `${environment.baseUrl}/pahdp-opportunity/v1/opportunities`;
